//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import { Dialog, Toast, Notify } from "vant";
import zwtp from "../../assets/img/zwtp.png";

export default {
  name: "activitiesSelected",
  components: {
    footerNav
  },
  data() {
    return {
      item: {},
      loading: false,
      isShow: false,
      finished: false,
      zwtp,
      start: 0,
      size: 0,
      itemList: []
    };
  },
  created() {},
  mounted() {
    this.item = JSON.parse(this.$route.query.row);
    this.onLoad();
  },
  methods: {
    delect() {
      var arr = [];
      this.itemList.forEach(item => {
        if (item.checked) {
          arr.push({ sampleSelectDetailId: item.sampleSelectDetailId });
        }
      });
      if (arr.length > 0) {
        axiosApi
          .getSampleMobileDeptDecete({
            sampleSelectId: this.item.sampleSelectId,
            spuDeptId: this.$route.query.spuDeptId,
            sampleSelectColorList: arr
          })
          .then(res => {
            this.start = 0;
            this.size = 0;
            this.onLoad();
          })
          .catch(err => {});
      } else {
        Notify({ type: "danger", message: "请选择" });
      }
    },
    bottomClick() {
      if (this.itemList.length > 0) {
        axiosApi
          .getSampleMobileDeptOrderEnd({
            sampleSelectId: this.item.sampleSelectId,
            spuDeptId: this.$route.query.spuDeptId
          })
          .then(res => {
            this.$router.push({
              name: "activitiesSelection"
            });
          })
          .catch(err => {});
      } else {
        Notify({ type: "danger", message: "请选择" });
      }
    },
    add() {
      this.$router.push({
        name: "selectSampleHK",
        query: {
          row: JSON.stringify(this.item),
          spuDeptId: this.$route.query.spuDeptId
        }
      });
    },
    GridCheck(item) {
      item.checked = !item.checked;
    },
    onLoad() {
      this.size = this.size + 20;
      axiosApi
        .getSampleMobileDeptSelected({
          start: this.start,
          size: this.size,
          sampleSelectId: this.item.sampleSelectId,
          spuDeptId: this.$route.query.spuDeptId,
          orderRules: [
            {
              orderKey: "t1.crtTime",
              desc: true
            },
            {
              orderKey: "t2.sampleId",
              desc: true
            }
          ]
        })
        .then(response => {
          if (
            response.content &&
            response.content.list &&
            response.content.list.length > 0
          ) {
            response.content.list.forEach(item => {
              item.checked = false;
              if (
                item.predictedSampleCost &&
                item.predictedSampleCost != "" &&
                item.predictedSampleCost != null
              ) {
              } else {
                item.predictedSampleCost = "暂无";
              }
            });
            var List = JSON.parse(JSON.stringify(this.itemList));
            this.itemList.splice(0, this.itemList.length);
            this.itemList = response.content.list;
            this.itemList.forEach(item => {
              List.forEach(element => {
                if (element.sampleSelectDetailId == item.sampleSelectDetailId) {
                  item.checked = element.checked;
                }
              });
            });
          } else {
            this.itemList = [];
          }
          this.loading = false;
          if (this.itemList.length == response.content.total) {
            this.finished = true;
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/activitiesSelected.vue